import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles(theme => ({
  root: {
    marginRight: ({ modal }) => (modal ? '1rem' : '0 !important')
  },

  title: {
    marginTop: '0'
  },

  name: {
    [theme.breakpoints.down(1300)]: {
      maxWidth: 'unset'
    },

    [theme.breakpoints.down(400)]: {
      maxWidth: '150px'
    }
  },

  modalName: {
    maxWidth: 'unset !important'
  },

  content: {
    height: 'unset',

    [theme.breakpoints.up(1300)]: {
      width: '9rem'
    },

    [theme.breakpoints.down(1300)]: {
      width: 'unset'
    },

    [theme.breakpoints.down(400)]: {
      width: ({ modal }) => (modal ? '130px' : '170px')
    }
  },

  modalContent: {
    width: 'unset !important'
  },

  contentBlock: {
    flex: '1'
  },

  smallButtons: {
    display: 'flex'
  },

  controlsBlock: {
    marginTop: '0.25rem',
    marginRight: '1rem',
    marginBottom: '0.25rem'
  }
}))

export default useStyles
